import { render, staticRenderFns } from "./officialAccount.vue?vue&type=template&id=62590a4d&scoped=true"
import script from "./officialAccount.vue?vue&type=script&lang=js"
export * from "./officialAccount.vue?vue&type=script&lang=js"
import style0 from "./officialAccount.vue?vue&type=style&index=0&id=62590a4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62590a4d",
  null
  
)

export default component.exports